import { render, staticRenderFns } from "./RefahAuthorizationItem.vue?vue&type=template&id=d653070e&scoped=true"
import script from "./RefahAuthorizationItem.vue?vue&type=script&lang=js"
export * from "./RefahAuthorizationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d653070e",
  null
  
)

export default component.exports